/** @format */

import React, { Component } from "react";
import * as qs from "query-string";
import { Dropdown, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import debounce from "lodash.debounce";
import { ApiRoutes, AppRoutes, pagesOption } from "../../../../config";
import { ApiHelper } from "../../../../helpers";
import { ListRequestComponent } from "../../../components/clients";
import Pagination from "../../../components/pagination";
import { Breadcrumbs } from "../../../components/partial/Breadcrumbs";
import SweetAlertComponent from "../../../components/sweetAlertComponent";
import { FilterComponent } from "../../../components/filters";
import { SearchFilter } from "../../../components/filters/searchFilter";
import pageDropdownIcon from "../../../../assets/img/tag-bd.svg";
import filterarrowIcon from "../../../../assets/img/filter-arrow.svg";
import "../manage-clients.css";
import { AddFormComponent } from "../../../components/clients/AddFormComponent";

class ManageClientRequests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requests: [],
      errors: null,
      isLoading: false,
      isUpdating: false,
      updatingStatus: "",
      activeId: "",
      totalRecords: 0,
      currentPage: 1,
      limit: 11,
      sortBy: "all",
      order: "desc",
      sortByStatus: "all",
      search: "",
      isFormOpen: false,
      showAddForm: false,
    };
    this.emitSearch = debounce(this.onSearch, 200);
  }
  componentDidMount = () => {
    this.handleQueryParams();
  };
  handleQueryParams = () => {
    const {
      location: { search },
    } = this.props;

    const query = qs.parse(search);
    this.setState(
      {
        currentPage: query.page ? parseInt(query.page) : 1,
        limit: query.limit ? parseInt(query.limit) : 10,
        search: query.search || "",
        sortBy: query.sort || "all",
        order: query.order ? query.order : "desc",
        sortByStatus: query.status || "all",
      },
      () => this.fetchClientReq()
    );
  };

  componentDidUpdate = ({ location: { search: prevSearch } }) => {
    const {
      location: { search },
    } = this.props;
    if (prevSearch !== search) {
      this.handleQueryParams();
    }
  };
  fetchClientReq = async (loading = true) => {
    const { currentPage, limit, sortBy, order, sortByStatus, search } =
      this.state;
    let skip = limit * (currentPage - 1);
    let data = {
      skip,
      limit,
      sortBy,
      search,
      sortByStatus,
      order,
      // sortBy === 'createdAt' ? 'desc' : 'asc',
    };
    this.setState({
      isLoading: loading,
    });
    const response = await new ApiHelper().FetchFromServer(
      ApiRoutes.GET_CLIENTS_REQUEST.service,
      ApiRoutes.GET_CLIENTS_REQUEST.url,
      ApiRoutes.GET_CLIENTS_REQUEST.method,
      ApiRoutes.GET_CLIENTS_REQUEST.authenticate,
      data,
      undefined
    );
    this.setState({
      isLoading: false,
      isUpdating: false,
      activeId: "",
    });
    if (response && response.isError) {
      toast.error(response.messages[0]);
    } else {
      const {
        data: { clients, totalRecords },
      } = response.data;
      this.setState({
        requests: clients,
        totalRecords,
      });
    }
  };
  updateClientStatus = async (id, status, message) => {
    const { value } = await SweetAlertComponent({
      title: "Are you sure?",
      text: message,
    });
    if (!value) {
      return;
    }
    this.setState({
      isUpdating: true,
      updatingStatus: status,
      activeId: id,
    });
    const response = await new ApiHelper().FetchFromServer(
      ApiRoutes.UPDATE_CLIENT_STATUS.service,
      ApiRoutes.UPDATE_CLIENT_STATUS.url.replace(":id", id),
      ApiRoutes.UPDATE_CLIENT_STATUS.method,
      ApiRoutes.UPDATE_CLIENT_STATUS.authenticate,
      undefined,
      { status }
    );
    this.setState({
      isUpdating: false,
      activeId: "",
      updatingStatus: "",
    });
    if (response && response.isError) {
      toast.error(response.messages[0]);
    } else {
      await this.fetchClientReq(false);
      toast.success(response.messages[0]);
    }
  };
  resendInvitation = async (id) => {
    const { value } = await SweetAlertComponent({
      // title: 'Are you sure?',
      text: "Are you sure, you want to resend invitation?",
    });
    if (!value) {
      return;
    }
    this.setState({
      isUpdating: true,
      activeId: id,
      updatingStatus: "Invited",
    });
    const response = await new ApiHelper().FetchFromServer(
      ApiRoutes.RESEND_INVITATION_TO_CLIENT.service,
      ApiRoutes.RESEND_INVITATION_TO_CLIENT.url.replace(":id", id),
      ApiRoutes.RESEND_INVITATION_TO_CLIENT.method,
      ApiRoutes.RESEND_INVITATION_TO_CLIENT.authenticate,
      undefined,
      undefined
    );
    this.setState({
      isUpdating: false,
      activeId: "",
      updatingStatus: "",
    });
    if (response && response.isError) {
      toast.error(response.messages[0]);
    } else {
      await this.fetchClientReq(false);
      toast.success(response.messages[0]);
    }
  };
  onPageChanged = (page) => {
    const { currentPage } = this.state;
    if (page !== currentPage) {
      const {
        location: { search, pathname },
      } = this.props;
      const query = qs.parse(search);
      this.props.history.push(
        [pathname, qs.stringify({ ...query, page })].join("?")
      );
    }
  };

  onLimitChange = (limit) => {
    const {
      location: { search, pathname },
    } = this.props;
    const query = qs.parse(search);
    this.props.history.push(
      [pathname, qs.stringify({ ...query, page: 1, limit })].join("?")
    );
  };
  setFilter = (sortBy, order) => {
    const {
      props: {
        location: { pathname },
      },
    } = this;
    let params = {};
    params.page = 1;
    if (sortBy) {
      params.sort = sortBy;
    }
    if (order) {
      params.order = order;
    }
    this.props.history.push([pathname, qs.stringify(params)].join("?"));
  };
  setStatusFilter = (sortBy) => {
    const {
      props: {
        location: { pathname },
      },
    } = this;
    let params = {};
    params.page = 1;
    params.status = sortBy;
    this.props.history.push([pathname, qs.stringify(params)].join("?"));
  };

  handleChange = (event) => {
    const {
      target: { name, value },
    } = event;
    this.setState({ [name]: value });
  };
  onAddBtnClick = () => {
    this.setState((prevState) => ({
      isFormOpen: !prevState.isFormOpen,
    }));
  };
  onCancel = async (newAdded) => {
    // To fetch request after adding new client
    if (newAdded) {
      await this.fetchClientReq(false);
    }
    this.setState({
      showAddForm: false,
    });
  };

  viewHandler = (id) => {
    this.props.history.push(AppRoutes.VIEW_CLIENT_REQUEST.replace(":id", id));
  };
  editHandler = (id) => {
    this.props.history.push(AppRoutes.VIEW_CLIENT_REQUEST.replace(":id", id));
  };

  // To handle search on typing
  handleSearch = (event) => {
    const {
      target: { name, value },
    } = event;
    this.setState({ [name]: value });
    event.persist();
    this.emitSearch();
  };

  onSearch = () => {
    const { search } = this.state;
    const {
      props: {
        location: { search: searchParam, pathname },
      },
    } = this;
    const query = qs.parse(searchParam);
    let params = {};
    params.page = 1;
    params.search = search;
    this.props.history.push(
      [pathname, qs.stringify({ ...query, ...params })].join("?")
    );
  };
  onDelete = async (id) => {
    const { value } = await SweetAlertComponent({
      // title: 'Are you sure?',
      text: "Are you sure, you want to delete this request ?",
    });
    if (!value) {
      return;
    }
    this.setState({
      isLoading: true,
    });
    const response = await new ApiHelper().FetchFromServer(
      ApiRoutes.DELETE_INVITED_CLIENT.service,
      ApiRoutes.DELETE_INVITED_CLIENT.url.replace(":id", id),
      ApiRoutes.DELETE_INVITED_CLIENT.method,
      ApiRoutes.DELETE_INVITED_CLIENT.authenticate,
      undefined,
      undefined
    );
    this.setState({
      id: "",
    });
    if (response && response.isError) {
      toast.error(response.messages[0]);
      this.setState({
        isLoading: true,
      });
    } else {
      await this.fetchClientReq();
      toast.success(response.messages[0]);
    }
  };

  openAddModal = () => {
    this.setState({
      showAddForm: true,
      // faqs: this.state.faqs,
    });
    // this.fetchCategoryList();
  };

  render() {
    const {
      requests,
      isLoading,
      totalRecords,
      currentPage,
      limit,
      order,
      sortBy,
      sortByStatus,
      search,
      isFormOpen,
      isUpdating,
      updatingStatus,
      activeId,
    } = this.state;
    const {
      props: {
        location: { pathname },
      },
    } = this;

    const filtersOption = [
      { label: "All", value: "all" },
      { label: "Email", value: "email" },
      { label: "Company Name", value: "companyName" },
      { label: "Name", value: "name" },
      { label: "Date", value: "createdAt" },
    ];

    const filtersStatus = [
      {
        label: "All",
        value: "all",
      },
      {
        label: "Submitted",
        value: "Submitted",
      },
      // {
      //   label: 'Accepted',
      //   value: 'Accepted',
      // },
      {
        label: "Rejected",
        value: "Rejected",
      },
      {
        label: "Invited",
        value: "Invited",
      },
      {
        label: "Cancelled",
        value: "Cancelled",
      },
    ];
    return (
      <div className="container-fluid fluid-pd-2">
        <h1 className="h3-head-mob d-md-none">View Client</h1>
        <Breadcrumbs pathname={pathname} />
        <div className="card card-pagination card-main">
          <div className="card-header  py-7550  align-items-center justify-content-between">
            <div className="row">
              <div className="col-md-3 head-col-lg">
                <h6 className="font-book ">View Client Requests</h6>
              </div>

              <div className="col-md-10  mob-filter-data">
                <Dropdown className="no-arrow dp-right">
                  <Dropdown.Toggle
                    variant="secondary"
                    id="dropdown-basic"
                    className={"filter-btn-mob"}
                  >
                    {" "}
                    <span className="staff-value">
                      {
                        (
                          pagesOption.filter(
                            (filter) => filter.value === limit
                          )[0] || {}
                        ).label
                      }
                    </span>{" "}
                    <img src={pageDropdownIcon} alt="" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="shadow dropdown-menu-right dropdown-opt-mob mob-drp">
                    {filtersOption.map(({ label, value, order }, index) => (
                      <Dropdown.Item
                        as="div"
                        key={index}
                        onClick={() => this.setFilter(value, order)}
                      >
                        {label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>

                <div className="dropdown no-arrow dp-right">
                  <button
                    className="btn btn-secondary filter-btn-mob"
                    id="statusMenuLink-mob"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img src="img/tag-search-bd.svg" alt="" />
                  </button>
                </div>
              </div>

              <div className="col-md-9 filter-col-lg">
                <div className="dp-right">
                  <button
                    className="btn btn-primary add-btn add-wd-1024"
                    onClick={this.openAddModal}
                  >
                    {" "}
                    Add Client
                  </button>
                </div>
                <FilterComponent
                  options={filtersStatus}
                  label={"Status"}
                  selectedFilter={sortByStatus}
                  onFilterChange={(selectedValue) =>
                    this.setStatusFilter(selectedValue, "status")
                  }
                />
                <FilterComponent
                  options={filtersOption}
                  selectedFilter={sortBy}
                  onFilterChange={this.setFilter}
                />
                {/* <FilterComponent
                  options={filtersOption}
                  selectedFilter={sortBy}
                  onFilterChange={(selectedValue) =>
                    this.setFilter(selectedValue, "sort")
                  }
                /> */}
                <SearchFilter
                  id={"sm-search-filter"}
                  placeholder={"Search by Store and Company name"}
                  search={search}
                  onChange={this.handleSearch}
                />
              </div>
            </div>
          </div>
          <ListRequestComponent
            requests={requests}
            isLoading={isLoading}
            isUpdating={isUpdating}
            updatingStatus={updatingStatus}
            activeId={activeId}
            isFormOpen={isFormOpen}
            onCancel={this.onCancel}
            viewHandler={this.viewHandler}
            updateStatus={this.updateClientStatus}
            resendInvitation={this.resendInvitation}
            onDelete={this.onDelete}
            editHandler={this.editHandler}
            setFilter={this.setFilter}
            order={order}
            sortBy={sortBy}
          />
        </div>
        <div className="footer-pg custom-align">
          {!isLoading ? (
            <div className="float-left mt-2">
              <p className="page-desc-left">
                Total: <span className="bold-black">{totalRecords}</span>
              </p>
            </div>
          ) : null}
          <div className="float-right mt-2">
            <p className="page-desc ml-2 float-right">Table View</p>

            <Dropdown className="no-arrow dp-right ml-2">
              <Dropdown.Toggle
                variant="secondary"
                id="dropdown-basic"
                className={"filter-btn"}
              >
                {" "}
                <span className="staff-value">
                  {
                    (
                      pagesOption.filter(
                        (filter) => filter.value === limit
                      )[0] || {}
                    ).label
                  }
                </span>{" "}
                <img src={filterarrowIcon} alt="" />
              </Dropdown.Toggle>
              <Dropdown.Menu className="shadow top-open dropdown-menu-right dropdown-staff">
                {pagesOption.map(({ label, value }, index) => (
                  <Dropdown.Item
                    as="div"
                    key={index}
                    onClick={() => this.onLimitChange(value)}
                  >
                    {label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            {!isLoading && totalRecords > limit ? (
              <div className="float-right">
                <Pagination
                  totalRecords={totalRecords}
                  currentPage={currentPage}
                  pageLimit={limit}
                  onPageChanged={this.onPageChanged}
                />
              </div>
            ) : null}
          </div>
        </div>

        <Modal
          show={this.state.showAddForm}
          // onHide={this.handleAddCancel.bind(this)}
          className="proAddCZ inviteClient_modal"
          centered
        >
          <Modal.Body>
            <AddFormComponent onCancel={this.onCancel} />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default ManageClientRequests;
